<template>
  <div class="box12" id="box12">
    <pageTitle
      title="技术学到位&nbsp;&nbsp;高薪offer就不难"
      text="据博学谷内部统计，0基础跨行学习软件测试的学生约占70%"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <div class="content-box" @scroll="handleScroll">
      <div class="content" ref="content">
        <div class="content-top">
          <div class="name">姓名</div>
          <div class="work">学前岗位</div>
          <div class="day">学习天数</div>
          <div class="newSalay">就业薪资</div>
          <div class="city">就业城市</div>
          <div class="age">年龄</div>
          <div class="major">大学专业</div>
          <div class="education">学历</div>
          
        </div>
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="work">{{ item.work }}</div>
          <div class="day">{{ item.day }}</div>
          <div class="newSalay">{{ item.newSalay }}</div>
          <div class="city">{{ item.city }}</div>
          <div class="age">{{ item.age }}</div>
          <div class="major">{{ item.major }}</div>
          <div class="education">{{ item.education }}</div>
          
        </div>
      </div>
      <div class="seat"></div>
    </div>
    <div class="tip">
      数据来源：博学谷就业中心软件测试学科就业数据
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          name: "陈**",
          age: "31",
          education: "本科",
          major: "计科",
          work: "开发工程师",
          day: "50",
          newSalay: "15600",
          city: "珠海"
        },
        {
          name: "郑**",
          age: "30",
          education: "专科",
          major: "数控应用",
          work: "整机测试",
          day: "-",
          newSalay: "15000",
          city: "广州"
        },
        {
          name: "刘**",
          age: "32",
          education: "研究生",
          major: "计科",
          work: "测试工程师",
          day: "82",
          newSalay: "15000",
          city: "上海"
        },
        {
          name: "王*",
          age: "31",
          education: "专科",
          major: "计科",
          work: "开发工程师",
          day: "47",
          newSalay: "13000",
          city: "天津"
        },
        {
          name: "张*",
          age: "27",
          education: "本科",
          major: "网络工程",
          work: "Java开发",
          day: "52",
          newSalay: "12400",
          city: "重庆"
        },
        {
          name: "姬*",
          age: "26",
          education: "本科",
          major: "通信工程",
          work: "测试工程师",
          day: "85",
          newSalay: "12000",
          city: "长沙"
        },
        {
          name: "郭**",
          age: "23",
          education: "本科",
          major: "软件工程",
          work: "无",
          day: "112",
          newSalay: "9000",
          city: "武汉"
        },
        {
          name: "刘*",
          age: "29",
          education: "本科",
          major: "建筑学",
          work: "建筑",
          day: "128",
          newSalay: "9000",
          city: "武汉"
        },
        {
          name: "张**",
          age: "23",
          education: "本科",
          major: "计科",
          work: "车载测试",
          day: "97",
          newSalay: "8000",
          city: "重庆"
        },
        {
          name: "龚**",
          age: "24",
          education: "本科",
          major: "工程力学",
          work: "土建工程师",
          day: "93",
          newSalay: "8000",
          city: "北京"
        },
        {
          name: "顾**",
          age: "25",
          education: "本科",
          major: "计科",
          work: "测试",
          day: "89",
          newSalay: "11500",
          city: "南京"
        },
        {
          name: "陈**",
          age: "19",
          education: "专科",
          major: "啤酒酿造",
          work: "Java开发",
          day: "93",
          newSalay: "13000",
          city: "深圳"
        },
        {
          name: "饶**",
          age: "25",
          education: "本科",
          major: "软件工程",
          work: "应届生",
          day: "97",
          newSalay: "10500",
          city: "杭州"
        },
        {
          name: "高**",
          age: "25",
          education: "本科",
          major: "计科",
          work: "运维工程师",
          day: "94",
          newSalay: "11000",
          city: "深圳"
        },
        {
          name: "黄*",
          age: "24",
          education: "本科",
          major: "软件工程",
          work: "应届生",
          day: "91",
          newSalay: "9000",
          city: "深圳"
        },
        {
          name: "邹**",
          age: "24",
          education: "本科",
          major: "计科学",
          work: "工艺工程师",
          day: "116",
          newSalay: "9000",
          city: "南京"
        },
        {
          name: "李*",
          age: "23",
          education: "本科",
          major: "数据科学",
          work: "行政",
          day: "65",
          newSalay: "9000",
          city: "珠海"
        },
        {
          name: "崔**",
          age: "29",
          education: "研究生",
          major: "测控技术",
          work: "技术支持",
          day: "108",
          newSalay: "15000",
          city: "杭州"
        },
        {
          name: "潘*",
          age: "25",
          education: "专科",
          major: "测绘工程",
          work: "测绘内业",
          day: "109",
          newSalay: "8000",
          city: "保密"
        },
        {
          name: "沈**",
          age: "27",
          education: "本科",
          major: "机械电子",
          work: "技术员",
          day: "90",
          newSalay: "10000",
          city: "苏州"
        }
      ],
      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  mounted() {},
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  position: relative;
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box12/bg.png")
    no-repeat;
  background-size: cover;
  overflow: hidden;

  .left-box {
    position: absolute;
    top: 240px;
    left: 0px;
    box-shadow: 8px 0px 16px 0px rgba(64, 128, 255, 0.06);
    div {
      width: 100%;
      height: 97px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      text-align: center;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
      box-sizing: border-box;
      &:first-child {
        background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
        font-size: 24px;
        font-family: PingFangSC-Medium;
        color: #1d2129;
        font-weight: 500;
        border-bottom: none;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }

  .scorll-box {
    position: absolute;
    left: 50%;
    bottom: 144px;
    transform: translate(-50%, 0px);
    width: 40px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }

  .content-box {
    width: 100%;
    padding: 0px 0 0 32px;
    padding-bottom: 22px;
    overflow-x: auto;
    box-sizing: border-box;
    display: flex;
    .seat {
      width: 32px;
      flex-shrink: 0;
    }
  }
  .content-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .content {
    margin-top: 48px;
    width: 1040px;
    flex-shrink: 0;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow-x: hidden;
    // overflow-y: scroll;

    .sex {
      width: 96px;
    }
    .age {
      width: 96px;
    }

    .major {
      width: 152px;
    }

    .education {
      width: 96px;
    }

    .day {
      width: 128px;
    }

    .name {
      width: 120px;
    }

    .work {
      width: 144px;
    }

    .oldSalay {
      width: 144px;
    }
    .newSalay {
      width: 144px;
    }
    .city {
      width: 144px;
    }

    .content-top {
      display: flex;
      width: 100%;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      color: #1d2129;
    }

    .item {
      display: flex;
      width: 100%;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);

      .newSalay {
        color: #2ea5fc;
      }
    }
  }

  .tip {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #b9c8d9;
    line-height: 36px;
  }
}
</style>
